import { Pipe, PipeTransform } from '@angular/core';
import { TabloGroupConfig } from '@ui/tablo-generator/types';

@Pipe({
    name: 'calculateBackgroundForChild',
    standalone: false
})
export class CalculateBackgroundForChildPipe implements PipeTransform {
  transform(
    rules: TabloGroupConfig,
    index: number,
    row: number,
  ): string | null {
    const prop = 'childBackgroundColor';
    const borderFrameWidth = 'childFrameWidth';
    const photoSideMarginsIndex = 'photoSideMargins';
    let hasBorderFrame = false;
    let photoSideMargins = 0;
    if (
      typeof rules.singleChildConfig !== 'undefined' &&
      typeof rules.singleChildConfig[index] !== 'undefined' &&
      typeof rules.singleChildConfig[index][borderFrameWidth] !== 'undefined'
    ) {
      hasBorderFrame = rules.singleChildConfig[index][borderFrameWidth] > 0;
    }
    if (!hasBorderFrame) {
      switch (rules.childConfigDifferenceRule) {
        case 'none':
          hasBorderFrame = Number(rules[borderFrameWidth]) > 0;
          photoSideMargins = Number(rules.photoSideMargins);
          break;
        case 'oddEven':
          hasBorderFrame =
            rules[`${borderFrameWidth}${index % 2 === 0 ? 'Even' : 'Odd'}`] > 0;
          photoSideMargins =
            rules[
              `${photoSideMarginsIndex}${index % 2 === 0 ? 'Even' : 'Odd'}`
            ];
          break;
        case 'oddEvenRow':
          hasBorderFrame =
            rules[`${borderFrameWidth}${row % 2 !== 0 ? 'Even' : 'Odd'}`] > 0;
          photoSideMargins =
            rules[`${photoSideMarginsIndex}${row % 2 !== 0 ? 'Even' : 'Odd'}`];
          break;
      }
    }
    if (hasBorderFrame && !photoSideMargins) {
      const childFrameColor = 'childFrameColor';
      if (
        typeof rules.singleChildConfig !== 'undefined' &&
        typeof rules.singleChildConfig[index] !== 'undefined' &&
        typeof rules.singleChildConfig[index][childFrameColor as string] !==
          'undefined'
      ) {
        return rules.singleChildConfig[index][childFrameColor as string];
      }
      switch (rules.childConfigDifferenceRule) {
        case 'none':
          return rules[childFrameColor];
        case 'oddEven':
          return rules[`${childFrameColor}${index % 2 === 0 ? 'Even' : 'Odd'}`];
        case 'oddEvenRow':
          return rules[`${childFrameColor}${row % 2 !== 0 ? 'Even' : 'Odd'}`];
      }
    }
    if (
      typeof rules.singleChildConfig !== 'undefined' &&
      typeof rules.singleChildConfig[index] !== 'undefined' &&
      typeof rules.singleChildConfig[index][prop as string] !== 'undefined'
    ) {
      return rules.singleChildConfig[index][prop as string];
    }
    switch (rules.childConfigDifferenceRule) {
      case 'none':
        return rules[prop];
      case 'oddEven':
        return rules[`${prop}${index % 2 === 0 ? 'Even' : 'Odd'}`];
      case 'oddEvenRow':
        return rules[`${prop}${row % 2 !== 0 ? 'Even' : 'Odd'}`];
    }
    return null;
  }
}
